import * as React from "react";
import { SVGProps, memo } from "react";

const SvgBowing = (props: SVGProps<SVGSVGElement>) => (
  <svg width={70} height={98} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#Bowing_svg__a)">
      <path
        d="M47.91 4.947C42.207.25 33.968-.492 27.59 3.12l.02.021C8.15 8.937 8.957 34.046 20.773 45.1c5.663 5.3 13.517 7.518 22.155 3.374 0 0 10.29-6.664 12.796-12.495.72-1.68 1.77-4.319 2.086-7.147.518-4.76-.091-9.674-1.953-14.042s-4.998-8.148-8.96-10.479"
        fill="#2BA168"
      />

      <path
        d="M47.463 4.948C42.45 1.588 37.41.14 32.09 1.203a17.986 17.986 0 0 0-5.222 1.918l.02.021c-6.04 1.778-9.022 5.362-11.48 9.807-5.564 10.06-3.758 24.486 4.544 32.158 5.74 5.3 13.699 7.518 22.456 3.374 0 0 10.43-6.664 12.97-12.495.736-1.68 1.8-4.319 2.115-7.147.525-4.76-.091-9.674-1.974-14.042-1.89-4.368-5.425-8.078-8.05-9.835l-.007-.014Z"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="Bowing_svg__b"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={19}
        y={46}
        width={17}
        height={28}
      >
        <path d="M35.1 46.695H19.56v26.908H35.1V46.695Z" fill="#fff" />
      </mask>

      <g mask="url(#Bowing_svg__b)">
        <path
          d="M30.46 49.48s.518 4.151-.224 7.931a6.713 6.713 0 0 1-.714 1.94c-.364.664-1.61 1.847-2.317 2.232-2.443 1.316-5.166 2.22-5.166 2.22-1.043.461-1.967 2.372-1.463 4.164.7 2.464 2.359 2.933 4.242 3.465.497.14.994.294 1.77.427 4.187.714 8.632 1.47 11.005.308 3.465-1.694.924-7.79.189-13.839-.56-4.599 1.49-9.499-1.162-10.556-2.058-.819-6.153 1.715-6.153 1.715l-.007-.007Z"
          fill="#fff"
          stroke="#272C33"
          strokeWidth={1.75}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <mask
        id="Bowing_svg__c"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={35}
        y={46}
        width={16}
        height={28}
      >
        <path d="M50.643 46.695h-15.54v26.908h15.54V46.695Z" fill="#fff" />
      </mask>

      <g mask="url(#Bowing_svg__c)">
        <path
          d="M39.738 49.48s-.518 4.151.224 7.931c.091.455.28 1.155.714 1.94.364.664 1.61 1.847 2.317 2.232 2.443 1.316 5.166 2.22 5.166 2.22 1.043.461 1.967 2.372 1.463 4.164-.7 2.464-2.359 2.933-4.242 3.465-.497.14-.994.294-1.77.427-4.187.714-8.632 1.47-11.005.308-3.465-1.694-.924-7.79-.189-13.839.56-4.599-1.49-9.499 1.162-10.556 2.058-.819 6.153 1.715 6.153 1.715l.007-.007Z"
          fill="#fff"
          stroke="#272C33"
          strokeWidth={1.75}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <path
        d="M48.2 63.786s-2.716-.903-5.166-2.219c-.714-.385-1.953-1.568-2.317-2.233a6.785 6.785 0 0 1-.714-1.939c-.742-3.78-.224-7.93-.224-7.93s-1.106-.68-2.457-1.226a1.936 1.936 0 0 0-.707-.49c-.427-.168-.945-.189-1.498-.126-.553-.07-1.071-.049-1.498.126a1.936 1.936 0 0 0-.707.49c-1.351.54-2.457 1.225-2.457 1.225s.518 4.151-.224 7.931a6.713 6.713 0 0 1-.714 1.94c-.364.664-1.61 1.847-2.317 2.232-2.443 1.316-5.166 2.22-5.166 2.22-1.043.461-1.967 2.372-1.463 4.164.7 2.464 2.359 2.933 4.242 3.465.497.14.994.294 1.77.427 2.997.511 6.126 1.036 8.534.875 2.408.161 5.53-.364 8.526-.875.784-.133 1.274-.287 1.77-.427 1.89-.532 3.543-1 4.243-3.465.504-1.785-.413-3.696-1.463-4.165h.007Z"
        fill="#fff"
      />

      <path
        d="M48.2 63.786s-2.716-.903-5.166-2.219c-.714-.385-1.953-1.568-2.317-2.233a6.785 6.785 0 0 1-.714-1.939c-.742-3.78-.224-7.93-.224-7.93s-1.106-.68-2.457-1.226a1.936 1.936 0 0 0-.707-.49c-.427-.168-.945-.189-1.498-.126-.553-.07-1.071-.049-1.498.126a1.936 1.936 0 0 0-.707.49c-1.351.54-2.457 1.225-2.457 1.225s.518 4.151-.224 7.931a6.713 6.713 0 0 1-.714 1.94c-.364.664-1.61 1.847-2.317 2.232-2.443 1.316-5.166 2.22-5.166 2.22-1.043.461-1.967 2.372-1.463 4.164.7 2.464 2.359 2.933 4.242 3.465.497.14.994.294 1.77.427 2.997.511 6.126 1.036 8.534.875 2.408.161 5.53-.364 8.526-.875.784-.133 1.274-.287 1.77-.427 1.89-.532 3.543-1 4.243-3.465.504-1.785-.413-3.696-1.463-4.165h.007Z"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.276 55.305c.414.033.81.057 1.162.068l.02-.183c.986-.114 1.953-.268 2.612-.44 2.247-.574 4.886-1.519 8.127-4.466 1.827-1.659 3.059-3.549 4.228-6.153 2.513-.35 4.795-2.135 5.67-4.5.35-.939.483-1.968.259-2.94-.224-.974-.84-1.877-1.73-2.332-.888-.455-2.05-.406-2.638-.077a26.153 26.153 0 0 0-1.59-15.603c-.923-2.142-2.162-4.179-3.891-5.747-1.724-1.556-3.86-2.573-6.115-3.176l.053-.492c-2.052-.143-4.114-.286-6.167-.261-2.053-.025-4.115.118-6.167.261l.053.492c-2.255.603-4.391 1.62-6.115 3.176-1.729 1.568-2.968 3.605-3.892 5.747a26.153 26.153 0 0 0-1.589 15.603c-.588-.329-1.75-.378-2.639.077-.889.455-1.505 1.358-1.729 2.331-.224.973-.09 2.002.26 2.94.874 2.366 3.156 4.151 5.67 4.501 1.168 2.604 2.4 4.494 4.227 6.153 3.241 2.947 5.88 3.892 8.127 4.466.659.172 1.627.326 2.612.44l.02.183c.353-.011.748-.035 1.162-.068Z"
        fill="#fff"
      />

      <path
        d="M30.596 54.636c-1.582-.532-4.2-1.547-7.133-4.214-1.89-1.715-3.164-3.668-4.368-6.356-2.604-.357-4.956-2.205-5.859-4.655-.357-.966-.497-2.037-.266-3.045.231-1.008.868-1.939 1.785-2.415.917-.469 2.121-.42 2.73-.084-.343-3.01-.84-10.255 2.31-16.779 1.708-3.535 3.696-5.236 4.165-5.62a14.348 14.348 0 0 1 5.971-2.976c5.348-1.302 10.899-.3 12.229.567"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M39.612 54.526c1.582-.532 4.2-1.547 7.133-4.214 1.89-1.715 3.164-3.668 4.368-6.356 2.604-.357 4.956-2.205 5.859-4.655.357-.966.497-2.037.266-3.045-.231-1.008-.868-1.94-1.785-2.415-.917-.47-2.121-.42-2.73-.084.343-3.01.84-10.255-2.31-16.78-1.708-3.534-3.696-5.235-4.165-5.62-2.191-1.82-4.354-2.492-5.971-2.975-4.844-1.456-9.044.049-11.998.63"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="Bowing_svg__d"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={22}
        y={24}
        width={7}
        height={4}
      >
        <path d="M28.642 24.64H22.7v3.13h5.943v-3.13Z" fill="#fff" />
      </mask>

      <g mask="url(#Bowing_svg__d)">
        <path
          d="M28.116 25.203a7.483 7.483 0 0 0-4.893 2.08"
          stroke="#272C33"
          strokeWidth={1.05}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <mask
        id="Bowing_svg__e"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={41}
        y={24}
        width={7}
        height={4}
      >
        <path d="M47.659 24.64h-5.943v3.13h5.943v-3.13Z" fill="#fff" />
      </mask>

      <g mask="url(#Bowing_svg__e)">
        <path
          d="M42.24 25.203a7.483 7.483 0 0 1 4.893 2.08"
          stroke="#272C33"
          strokeWidth={1.05}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <path
        d="M48.138 29.496c-1.974-.294-6.867-1.302-11.382-5.299-4.053-3.584-5.698-7.714-6.328-9.625-.301 2.08-1.134 5.873-3.836 9.71-3.78 5.375-8.883 7.517-10.871 8.238-1.001-.553-.238-.616-.637-1.694-.357-.973-.721-2.632-.84-3.66-.154-1.282.21-3.788.448-5.062.16-.875.42-1.799.79-2.919.799-2.408 1.625-4.907 3.396-7.315 2.317-3.157 5.159-4.697 6.6-5.46 4.41-2.324 8.4-2.457 9.598-2.457 1.379 0 2.436.133 2.87.203 4.949.735 8.239 3.255 9.576 4.312 2.73 2.15 4.27 4.403 4.739 5.11 4.928 7.497 3.178 15.372 2.709 16.835-.161.511-.735 2.303-1.015 2.247-.042-.007-.07-.056-.084-.09"
        fill="#2BA168"
      />

      <path
        d="M38.464 16.953c2.877 6.594 8.687 12.39 15.148 15.568L38.464 16.953Z"
        fill="#2BA168"
      />

      <path
        d="M16.7 32.184c8.113-4.255 12.467-9.064 13.58-17.996.273.79.679 1.854 1.288 3.065.406.813 2.044 3.962 4.76 6.573 4.333 4.159 9.744 5.341 11.809 5.698"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M38.461 16.93c2.877 6.594 8.631 12.362 15.1 15.54"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M45.493 64.888c-7.427 1.057-15 1.064-22.407-.091 0 .035.014.07.014.273a28.053 28.053 0 0 0-5.243 11.298c-.273 1.295-.455 2.604-.637 3.913-.315 2.247-.623 4.5-.938 6.748a209.99 209.99 0 0 0-.72 5.537c-1.156 10.269-.827 20.671-2.01 30.968.14.189.063.504-.16.588 0 .021.006.042.083.007 2.716 1.106 5.712 1.232 8.638 1.351l12.194.483c2.59.105 5.187.203 7.77-.014 4.354-.371 8.568-1.645 12.747-2.905.14-7.322-.315-14.651-1.35-21.903-1.114-7.784-2.899-15.47-3.809-23.282-.245-2.114-.427-4.25-1.008-6.3-.65-2.303-1.785-4.438-3.157-6.678l-.007.007Z"
        fill="#CAECD1"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M53.403 96.009c-1.036-1.603-1.547-2.394-2.086-3.276-.23-.371-1.876-3.052-3.1-5.313-1.933-3.584-5.195-9.632-4.782-14.434.224-2.611.525-3.542.525-3.542.49-1.512 1.134-2.338.917-3.542-.14-.784-.574-1.365-.924-1.736 0 0 1.652-.68 3.661-.47 1.26.134 2.366.659 2.366.659A28.841 28.841 0 0 1 59.668 75.1c1.106 2.128 1.94 4.389 2.772 6.636 2.247 6.076 5.502 11.865 6.734 18.22.924 4.782-1.274 9.087-5.537 11.012-2.702 1.218-14.665.161-19.782-.644-.539-6.265-.357-11.956.896-13.755 5.383-.028 10.766-.05 16.15-.077"
        fill="#fff"
      />

      <path
        d="M53.077 66.719c2.856 2.737 4.592 4.088 6.993 8.323.483.847 1.337 2.737 3.01 6.53 3.78 8.576 4.991 12.069 5.79 16.024.63 3.108.713 5.061.09 7.14-.273.917-1.078 3.514-3.416 5.243-1.582 1.169-2.212 1.575-7.854 2.877"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M17.31 96.009c1.037-1.603 1.548-2.394 2.087-3.276.23-.371 1.876-3.052 3.1-5.313 1.933-3.584 5.195-9.632 4.782-14.434-.224-2.611-.525-3.542-.525-3.542-.49-1.512-1.134-2.338-.917-3.542.14-.784.574-1.365.924-1.736 0 0-1.652-.68-3.661-.47-1.26.134-2.366.659-2.366.659A28.841 28.841 0 0 0 11.046 75.1c-1.106 2.128-1.94 4.389-2.772 6.636C6.027 87.812 2.772 93.6 1.54 99.956c-.924 4.782 1.274 9.087 5.537 11.012 2.702 1.218 14.665.161 19.782-.644.539-6.265.357-11.956-.896-13.755-5.383-.028-10.766-.05-16.15-.077"
        fill="#fff"
      />

      <path
        d="M15.763 80.05c-1.253 8.918-6.307 53.452-6.307 53.452h23.457s.315-28.532.308-32.571v-4.032c-.588-13.153-4.963-24.143-6.482-37.079-1.24.35-2.31.938-3.094 1.442-.28.182-.42 1.33-.49 1.652-.476 2.184-.63 2.821-.973 5.103-.343 2.282-.966 4.417-1.155 6.664-.021.238-.035.483.042.707.098.273.315.476.525.665a78.673 78.673 0 0 0 4.697 3.92c-.924 1.757-1.848 3.514-2.78 5.264-.09.182-.188.371-.181.574.007.196.16.343.266.511 2.037 3.27 7 7.4 9.037 10.668"
        fill="#fff"
      />

      <path
        d="M15.763 80.05c-1.253 8.918-6.307 53.452-6.307 53.452h23.457s.315-28.532.308-32.571v-4.032c-.588-13.153-4.963-24.143-6.482-37.079-1.24.35-2.31.938-3.094 1.442-.28.182-.42 1.33-.49 1.652-.476 2.184-.63 2.821-.973 5.103-.343 2.282-.966 4.417-1.155 6.664-.021.238-.035.483.042.707.098.273.315.476.525.665a78.673 78.673 0 0 0 4.697 3.92c-.924 1.757-1.848 3.514-2.78 5.264-.09.182-.188.371-.181.574.007.196.16.343.266.511 2.037 3.27 7 7.4 9.037 10.668"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M23.215 62.586c-1.967.952-4.424 3.269-5.404 3.976l5.404-3.976Z" fill="#fff" />

      <path
        d="M23.215 62.586c-1.967.952-4.424 3.269-5.404 3.976"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M54.947 80.05c1.253 8.918 6.307 53.452 6.307 53.452H37.797s-.315-28.532-.308-32.571v-4.032c.588-13.153 4.963-24.143 6.482-37.079 1.24.35 2.31.938 3.094 1.442.28.182.42 1.33.49 1.652.476 2.184.63 2.821.973 5.103.343 2.282.966 4.417 1.155 6.664.021.238.035.483-.042.707-.098.273-.315.476-.525.665a78.673 78.673 0 0 1-4.697 3.92c.924 1.757 1.848 3.514 2.78 5.264.09.182.188.371.181.574-.007.196-.16.343-.266.511-2.037 3.27-7 7.4-9.037 10.668"
        fill="#fff"
      />

      <path
        d="M54.947 80.05c1.253 8.918 6.307 53.452 6.307 53.452H37.797s-.315-28.532-.308-32.571v-4.032c.588-13.153 4.963-24.143 6.482-37.079 1.24.35 2.31.938 3.094 1.442.28.182.42 1.33.49 1.652.476 2.184.63 2.821.973 5.103.343 2.282.966 4.417 1.155 6.664.021.238.035.483-.042.707-.098.273-.315.476-.525.665a78.673 78.673 0 0 1-4.697 3.92c.924 1.757 1.848 3.514 2.78 5.264.09.182.188.371.181.574-.007.196-.16.343-.266.511-2.037 3.27-7 7.4-9.037 10.668"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M47.493 62.586c1.967.952 4.424 3.269 5.404 3.976l-5.404-3.976Z" fill="#fff" />

      <path
        d="M47.493 62.586c1.967.952 4.424 3.269 5.404 3.976M17.624 66.719c-2.856 2.737-4.592 4.088-6.993 8.323-.483.847-1.337 2.737-3.01 6.53-3.78 8.576-4.991 12.069-5.79 16.024-.63 3.108-.713 5.061-.09 7.14.273.917 1.078 3.514 3.416 5.243 1.582 1.169 2.212 1.575 7.854 2.877"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M35.24 42.64a4.703 4.703 0 0 0 .007 1.877"
        stroke="#272C33"
        strokeWidth={1.4}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />

      <path
        d="M28.9 37.497a3.77 3.77 0 0 1-2.15.44 3.702 3.702 0 0 1-1.952-.804"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />

      <path
        d="M24.79 38.619c.196-.217.399-.434.595-.658"
        stroke="#272C33"
        strokeWidth={1.064}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />

      <path
        d="M41.493 37.497a3.77 3.77 0 0 0 2.149.44 3.702 3.702 0 0 0 1.953-.804"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />

      <path
        d="M45.595 38.619c-.196-.217-.399-.434-.595-.658"
        stroke="#272C33"
        strokeWidth={1.064}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />

      <path
        d="M32.055 48.586s1.078.672 3.241.672c2.422 0 3.192-.672 3.192-.672"
        stroke="#272C33"
        strokeWidth={1.463}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />

      <path
        d="M48.514 48.43a15.107 15.107 0 0 1-1.77 1.904c-.183.16-.358.3-.533.455.084.455.126.938.063 1.344-.189 1.162-1.07 3.794-1.638 4.578-.567.784-2.31 3.143-2.604 3.458-.294.308-2.219 1.96-2.506 2.87-.294.91-.98 1.708-.588 3.52.392 1.814 1.554 3.158 1.554 3.158s-.028 1.239.546 2.506c.364.805.26.777.357.889.105.595.322 1.064.47 1.379 1.021 2.156 3.072 3.087 3.807 3.38 0 0-1.14-1.854-1.029-3.464.112-1.61.68-2.947 1.645-4.2 1.134-1.477 1.736-2.156 3.185-3.29 1.421-1.113 2.443-2.513 3.465-4.04 1.246-1.847 1.127-4.633.61-6.831-.477-2.037-1.338-4.536-5.04-7.616h.006Z"
        fill="#2BA168"
      />

      <path
        d="M48.73 48.148a15.357 15.357 0 0 1-1.987 2.184c-.182.16-.357.3-.532.455.105 1.204-.245 2.513-.854 4.06-.938 2.373-2.52 3.955-4.354 5.824-1.008 1.029-2.156 2.415-2.36 3.85-.237 1.694.337 3.584 1.506 4.809-.602 1.638.875 4.508 1.652 5.558 1.043 1.407 2.338 1.792 3.878 2.576 0 0-1.176-1.848-1.057-3.458s.7-2.94 1.694-4.193c1.169-1.47 1.792-2.15 3.276-3.283 1.463-1.113 2.513-2.506 3.57-4.032 1.28-1.841 1.162-4.62.63-6.818-.483-1.974-1.477-4.571-5.061-7.54v.008Z"
        stroke="#272C33"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <defs>
      <clipPath id="Bowing_svg__a">
        <path fill="#fff" d="M0 0h70v98H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgBowing);

export default Memo;
